import SkeletonElement from "@/components/Skeleton/SkeletonElement";

export default function PersonSideSheetSkeleton() {
  return (
    <div className="pt-7">
      {/* ObjectHeading Skeleton */}
      <div className="flex flex-col gap-6">
        <div data-testid="profile-skeleton" className="space-y-4">
          <div className="flex items-center space-x-4">
            <SkeletonElement height="h-12" width="w-12" rounded="rounded-full" />
            <div className="flex-1 space-y-2 py-1">
              <SkeletonElement height="h-4" width="w-3/4" rounded="rounded-full" />
              <SkeletonElement height="h-4" width="w-1/2" rounded="rounded-full" />
            </div>
          </div>
        </div>

        {/* View Person Button */}
        <SkeletonElement height="h-8" width="w-32" rounded="rounded-full" />
      </div>

      {/* Content Sections */}
      {/* Program Section */}
      <div className="flex flex-col gap-2 items-start mt-8">
        <SkeletonElement height="h-6" width="w-24" rounded="rounded-full" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-6" width="w-6" rounded="rounded-full" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-3" width="w-16" rounded="rounded-full" />
              <SkeletonElement height="h-4" width="w-48" rounded="rounded-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Phone Section */}
      <div className="flex flex-col gap-2 items-start mt-8">
        <SkeletonElement height="h-6" width="w-16" rounded="rounded-full" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-6" width="w-6" rounded="rounded-full" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-3" width="w-12" rounded="rounded-full" />
              <SkeletonElement height="h-4" width="w-32" rounded="rounded-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Email Section */}
      <div className="flex flex-col gap-2 items-start mt-8">
        <SkeletonElement height="h-6" width="w-12" rounded="rounded-full" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-6" width="w-6" rounded="rounded-full" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-4" width="w-64" rounded="rounded-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Addresses Section */}
      <div className="flex flex-col gap-2 items-start mt-8">
        <SkeletonElement height="h-6" width="w-20" rounded="rounded-full" />
        <div className="space-y-4 w-full">
          <div className="flex items-center gap-4">
            <SkeletonElement height="h-6" width="w-6" rounded="rounded-full" />
            <div className="flex-1 space-y-1">
              <SkeletonElement height="h-3" width="w-8" rounded="rounded-full" />
              <SkeletonElement height="h-4" width="w-64" rounded="rounded-full" />
              <SkeletonElement height="h-4" width="w-48" rounded="rounded-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
